// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast_container_container__\\+kwxQ {
    width: 300px;
    height: 60px;
    background-color: red;
    position: fixed;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 1rem 1rem 0;
    padding: 0 1rem;
    z-index: 999999999998;
    text-align: left;
}

.toast_container_progressBar__xtmkX {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 999999999999;
    height: 4px;
    background-color: #ccc;
    width: 100%;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.toast_container_closeButton__lCP9L {
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 0.3rem;
    margin-right: 0.5rem;
    cursor: pointer;
    z-index: 999999999999;
}

.toast_container_toastBottomRight__JH3Uy {
    bottom: 0;
    right: 0;
}

.toast_container_toastSuccess__i0-Be {
    background-color: #01B20B;
    color: #ffffff;
}

.toast_container_toastWarning__x9PYa {
    background-color: #EDBA0F;
    color: #ffffff;
}

.toast_container_toastError__MRGZP {
    background-color: #E23E31;
    color: #ffffff;
}

.toast_container_toastInfo__1KUSa {
    background-color: #2C8BD1;
    color: #ffffff;
}

.toast_container_toastDark__8howL {
    background-color: #110F10;
    color: #ffffff;
}

.toast_container_progressBarSuccess__-cTgH {
    background-color: #A8E8AD;
}

.toast_container_progressBarError__UwnIZ {
    background-color: #E4C9C3;
}

.toast_container_progressBarWarning__9\\+fr7 {
    background-color: #F8E9B0;
}

.toast_container_progressBarInfo__qRT8p {
    background-color: #B6DCF3;
}

.toast_container_progressBarDarkSuccess__-YZiz {
    background-color: #01B20B;
}

.toast_container_progressBarDarkError__Uq6zW {
    background-color: #E23E31;
}`, "",{"version":3,"sources":["webpack://./src/components/toasts/toast/toast_container.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,qBAAqB;IACrB,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".container {\n    width: 300px;\n    height: 60px;\n    background-color: red;\n    position: fixed;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin: 0 1rem 1rem 0;\n    padding: 0 1rem;\n    z-index: 999999999998;\n    text-align: left;\n}\n\n.progressBar {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    z-index: 999999999999;\n    height: 4px;\n    background-color: #ccc;\n    width: 100%;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n}\n\n.closeButton {\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin-top: 0.3rem;\n    margin-right: 0.5rem;\n    cursor: pointer;\n    z-index: 999999999999;\n}\n\n.toastBottomRight {\n    bottom: 0;\n    right: 0;\n}\n\n.toastSuccess {\n    background-color: #01B20B;\n    color: #ffffff;\n}\n\n.toastWarning {\n    background-color: #EDBA0F;\n    color: #ffffff;\n}\n\n.toastError {\n    background-color: #E23E31;\n    color: #ffffff;\n}\n\n.toastInfo {\n    background-color: #2C8BD1;\n    color: #ffffff;\n}\n\n.toastDark {\n    background-color: #110F10;\n    color: #ffffff;\n}\n\n.progressBarSuccess {\n    background-color: #A8E8AD;\n}\n\n.progressBarError {\n    background-color: #E4C9C3;\n}\n\n.progressBarWarning {\n    background-color: #F8E9B0;\n}\n\n.progressBarInfo {\n    background-color: #B6DCF3;\n}\n\n.progressBarDarkSuccess {\n    background-color: #01B20B;\n}\n\n.progressBarDarkError {\n    background-color: #E23E31;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `toast_container_container__+kwxQ`,
	"progressBar": `toast_container_progressBar__xtmkX`,
	"closeButton": `toast_container_closeButton__lCP9L`,
	"toastBottomRight": `toast_container_toastBottomRight__JH3Uy`,
	"toastSuccess": `toast_container_toastSuccess__i0-Be`,
	"toastWarning": `toast_container_toastWarning__x9PYa`,
	"toastError": `toast_container_toastError__MRGZP`,
	"toastInfo": `toast_container_toastInfo__1KUSa`,
	"toastDark": `toast_container_toastDark__8howL`,
	"progressBarSuccess": `toast_container_progressBarSuccess__-cTgH`,
	"progressBarError": `toast_container_progressBarError__UwnIZ`,
	"progressBarWarning": `toast_container_progressBarWarning__9+fr7`,
	"progressBarInfo": `toast_container_progressBarInfo__qRT8p`,
	"progressBarDarkSuccess": `toast_container_progressBarDarkSuccess__-YZiz`,
	"progressBarDarkError": `toast_container_progressBarDarkError__Uq6zW`
};
export default ___CSS_LOADER_EXPORT___;
